import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IAccount } from 'app/store/models/account.model';
import { IReferralPartner } from 'app/store/models/franchisee.model';
import { FranchiseeService } from 'app/franchisee/franchisee.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-franchisee-select-dialog',
  templateUrl: './franchisee-select-dialog.component.html',
  styleUrls: ['./franchisee-select-dialog.component.scss'],
})
export class FranchiseeSelectDialogComponent implements OnInit, OnDestroy {
  user: IAccount;
  franchisees: IAccount[] = [];
  inputForm: FormGroup;

  referralPartners: IReferralPartner[] = [];
  partnersLoading = false;

  private destroy$ = new Subject<void>();

  constructor(private franchiseeService: FranchiseeService) {}

  ngOnInit(): void {
    if (!this.inputForm) {
      return;
    }

    this.inputForm.addControl(
      'franchisee_id',
      new FormControl(this.user.franchisee_id || '', [Validators.required]),
    );
    this.inputForm.addControl(
      'referral_partner_id',
      new FormControl(
        this.user.referral_partner_id != null ? this.user.referral_partner_id : '',
      ),
    );

    const initialFranchiseeId = Number(this.user.franchisee_id);
    if (initialFranchiseeId) {
      this.loadPartners(initialFranchiseeId);
    }

    this.inputForm
      .get('franchisee_id')
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        const franchiseeId = Number(value);
        this.inputForm.get('referral_partner_id').setValue('');
        this.referralPartners = [];
        if (franchiseeId) {
          this.loadPartners(franchiseeId);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getFranchiseeItems() {
    const items = this.franchisees.map(franchisee => ({
      label: franchisee.email,
      value: franchisee.account_id,
    }));
    return [{ label: 'Please, select...', value: '' }, ...items];
  }

  getReferralPartnerItems() {
    const items = this.referralPartners.map(partner => ({
      label: partner.name,
      value: partner.id,
    }));
    return [{ label: 'None', value: '' }, ...items];
  }

  private loadPartners(franchiseeId: number) {
    this.partnersLoading = true;
    this.franchiseeService.listActiveReferralPartners(franchiseeId).subscribe(
      response => {
        this.referralPartners = response.items || [];
        this.partnersLoading = false;
      },
      () => {
        this.referralPartners = [];
        this.partnersLoading = false;
      },
    );
  }
}
